// extracted by mini-css-extract-plugin
export default {"header":"Header_header__d+igc","brand":"Header_brand__hPyCN","logo":"Header_logo__hLUwo","title":"Header_title__Md3AU"};